export default __webpack_public_path__ + "static/media/logoHRIS.a6067637.svg";